import { Group, People, Storage, Work } from "@mui/icons-material";
import { Box, Card, CardContent, Chip, Grid, Typography } from "@mui/material";
import { useMemo } from "react";
import { withRouter } from "react-router-dom";
import useFetch from "../../../hooks/http/useFetch";
import { IUserStoreState, useUserStore } from "../../../store/userState";
import { User } from "../../../icons/user";

const Metrics = () => {

  const { currentUser } = useUserStore() as IUserStoreState;
  const { data: metrics } = useFetch("/organization/resource/quota");

  const metricData = useMemo(() => [
    { label: 'Users', value: metrics?.seat || 0, icon: <User /> },
    { label: 'Groups', value: metrics?.group || 0, icon: <Group /> },
    { label: 'Projects', value: metrics?.project || 0, icon: <Work /> },
    { label: 'Assets', value: metrics?.asset || 0, icon: <Storage /> },
  ], [metrics?.asset, metrics?.group, metrics?.project, metrics?.seat]);

  if (currentUser?.role !== "owner") return null

  return <Card sx={{ border: "none", boxShadow: "none" }}>
    <CardContent
      sx={{
        display: "flex",
        flexDirection: "column",
        p: 3,
      }}
    >
      <Box
        sx={{
          flexGrow: 1,
        }}
      >
        <Grid sx={{ textAlign: "left" }} container>
          <Grid md={3}>
            <div>
              <Typography color="textPrimary" gutterBottom variant="h5">
                System Usage Metrics
              </Typography>
            </div>
          </Grid>

          <Grid md={9} spacing={3}>
            <Card sx={{ border: "none", boxShadow: "none" }}>
              <CardContent
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  p: 3,
                }}
              >
                <Box
                  sx={{
                    flexGrow: 1,
                  }}
                >
                  <Grid
                  container
                  sx={{pl:1}}
                  >
                    {metricData.map((metric, index) => (
                      <Grid
                        key={index}
                        xs={3}
                        
                      >
                        <Chip
                          icon={metric.icon}
                          label={`${metric.value}`}
                          color="default"
                          sx={{ mb: 1, fontSize: '1.2rem', fontWeight: 'bold' }}
                        />
                        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                          {metric.label}
                        </Typography>
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </CardContent>
  </Card>
};

export default withRouter(Metrics);
